import { useCallback, useState } from 'react';

import { hooks } from '@febos-io/common';

import { getPrices } from '../../config';

export function useCompanyPriceListEffect(companyId, referenceId, level, page, limit) {
  const [elements, setElements] = useState([]);
  const [meta, setMeta] = useState({ total: 0, pages: 0 });

  const {
    loading
  } = hooks.useEffectRequestCallback(
    useCallback(async (request) => {
      const {
        documents = [],
        total,
        totalPages: pages
      } = await request.exec(getPrices(companyId, referenceId, level, page, limit));
      setElements(documents);
      setMeta({ total, pages });
    }, [companyId, referenceId, level, page, limit])
  );

  return {
    loading,
    elements,
    meta,
    setElements
  };
}

export default useCompanyPriceListEffect;
